<template>
  <div class="drag_button">
    <div class="draggable-window"
         :style="styleObject"
         @mousedown="dragStart"
         @touchstart="dragStart"
         @mouseup="dragEnd"
         @touchend="dragEnd"
         @mousemove="drag"
         @touchmove="drag">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: "dragButton",
    props:{
      width:{
        type:Number,
        required:false,
        default:'100px'
      },
      height:{
        type:Number,
        required:false,
        default:'100px'
      },
      y:{
        type:Number,
        required:false,
        default:0
      },
      x:{
        type:Number,
        required:false,
        default:0
      },
      right:{
        type:Boolean,
        required:false,
        default:false
      },
      background:{
        type:String,
        required:false,
        default:'None'
      }
    },
    data() {
      return {
        dragging: false,
        initialX:0,
        initialY:0,
        mouseX: 0,
        mouseY: 0,
        offsetX: 0,
        offsetY: 0
      };
    },
    methods: {
      dragStart(e) {
        e.preventDefault();
        setTimeout(()=>{
          this.dragging = true;
        },100);
        this.mouseX = e.clientX || e.touches[0].clientX;
        this.mouseY = e.clientY || e.touches[0].clientY;
        this.offsetX = this.mouseX - this.initialX;
        this.offsetY = this.mouseY - this.initialY;
      },
      dragEnd() {
        if(!this.dragging) this.$emit('clicked');
        this.dragging = false;
      },
      drag(e) {
        if (this.dragging) {
          e.preventDefault();
          this.mouseX = e.clientX || e.touches[0].clientX;
          this.mouseY = e.clientY || e.touches[0].clientY;
          this.initialX = this.mouseX - this.offsetX;
          this.initialY = this.mouseY - this.offsetY;
        }
      }
    },
    computed:{
      styleObject() {
        return {
          top: this.initialY + 'px',
          left: this.initialX + 'px',
          width:this.width + 'px',
          height:this.height + 'px',
          background:this.background
        }
      }
    },
    mounted() {
      this.initialY = this.y;
      if(this.right){
        this.initialX = document.body.clientWidth - this.width - this.x;
      }else{
        this.initialX = this.x;
      }
    }
  };
</script>

<style>
  .draggable-window {
    position: absolute;
    z-index:88;
  }
</style>



// WEBPACK FOOTER //
// src/components/dragButton.vue